<template>
  <div class="package-tier-editor">
    <div class="info-editor">
      <label class="label">ชื่อ</label>
      <el-input class="input" v-model="value.name"></el-input>
      <label class="label">รายการ Package</label>
      <ruejai-club-package-selector
        class="input"
        v-model="value.packages"
        :disabled="disabled"
      ></ruejai-club-package-selector>
    </div>
  </div>
</template>

<script>
import { Input, Select, Option } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import RuejaiClubPackageSelector from "@/lib/components/RuejaiClubPackageSelector/RuejaiClubPackageSelector";

export default {
  props: ["value", "disabled"],
  components: {
    ScButton,
    RuejaiClubPackageSelector,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.package-tier-editor {
  .thumbnail-button {
    display: block;
    width: 100%;
  }
}

.image-container {
  flex: 0 0 225px;
  width: 225px;
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;

  &.quota {
    width: 80px;
  }
}

.input > textarea {
  min-height: 120px;
}

.thumbnail,
.image {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.target-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .image {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.target-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/features/ruejai-club/modules/tier/components/PackageTierEditor.vue